import * as types from '../constants/ActionTypes';
import { getSearchResult } from '../../lib/crawlSearchHelper';

export const getSearchObject = (searchpool) => ({ type: types.GET_SEARCH_OBJECT, payload: searchpool });

export const updateIntentQuery = (options) => ({ type: types.UPDATE_INTENT_QUERY, payload: options && options.query });

export const clearIntentSuggestion = () => ({ type: types.CLEAR_INTENT_SUGGESTION });

export const clearAllIntent = () => ({ type: types.CLEAR_ALL_INTENT });

export const hideSearchBar = () => ({ type: types.HIDE_INTENT_SUGGESTION });

// get intent suggestion from Fuse.js helper
export const getIntentSuggestion = (options) => {
  const suggestion = getSearchResult({ query: options && options.query, searchPool: options && options.searchPool });
  if (Array.isArray(suggestion) && suggestion.length) {
    return { type: types.GET_INTENT_SUGGESTION, payload: suggestion };
  }
  return { type: types.EMPTY_INTENT_SUGGESTION };
};
